// Masks
export const PATHING_TYPES = {
  WALKABLE: 1,
  BUILDABLE: 2,
};

export const DIRECTION = {
  DOWN: 0,
  LEFT: 1,
  UP: 2,
  RIGHT: 3,
};
